module.exports = "/packs/course-small-work-trial-5cefddf26b989f8af524bf6ddfe75f77.png";